/**
 * Whats Included
 */
$('.whats-included-accordion-item-title').on('click', function (e) {
  e.preventDefault();
  var $icon = $(this).find('.whats-included-accordion-item-title-icon');
  $(this).next('.whats-included-accordion-item-body').slideToggle(100);

  if ($icon.text().indexOf('+') !== -1) {
    $icon.text('–');
  } else {
    $icon.text('+');
  }
});

$('.whats-included-product').on('click', function (e) {
  e.preventDefault();
  var itemToShow = $(this).attr('data-whats-included-product');
  $('.whats-included-product').removeClass('whats-included-product--active');
  $(this).addClass('whats-included-product--active');

  $('.whats-included-accordion-section').hide();
  $('.whats-included-accordion-section[data-whats-included-product=' + itemToShow + ']').show();
});

$('.whats-included-accordion-item-body-accordion-item-title').on('click', function (e) {
  e.preventDefault();
  $(this).closest('.whats-included-accordion-item-body-accordion-item').toggleClass('is-active');
});

$(function () {

  const accordionElements = document.querySelectorAll('.whats-included-accordion-item');

  window.addEventListener('scroll', function () {
    for (const element of accordionElements) {
      const rect = element.getBoundingClientRect();
      const center = (window.innerHeight / 2);
      if (rect.top < center) {
        element.classList.add('scrolled-past-center');
      } else {
        element.classList.remove('scrolled-past-center');
      }
    }
  });
});